export async function toimitus_kuorma_create(toimitusId, keikkaBetoniId, keikkaId, token) {
  if (!toimitusId || toimitusId === 0) return { error: true, msg: "No toimitusId" };
  if (!keikkaBetoniId || keikkaBetoniId === 0) return { error: true, msg: "No keikkaBetoniId" };
  if (!keikkaId || keikkaId === 0) return { error: true, msg: "No keikkaId" };

  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/toimitus/kuorma/create";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      toimitusId: toimitusId,
      keikkaBetoniId: keikkaBetoniId,
      keikkaId: keikkaId,
    }),
  };
  const response = await fetch(fullUrl, requestOptions);
  const toimitusBetoniId = await response.json();

  return { error: false, msg: "", toimitusBetoniId: toimitusBetoniId };
}

export async function toimitus_kuorma_delete(toimitus = null, toimitusBetoniId, token) {
  if (toimitus) {
    const index = toimitus.betoniKuormat.findIndex((k) => k.toimitusBetoniId === toimitusBetoniId);
    if (index > -1) toimitus.betoniKuormat.splice(index, 1);
  }
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/toimitus/kuorma/delete";
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      toimitusBetoniId: toimitusBetoniId,
    }),
  };
  try {
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await response.json();
    if (cResponse.error || cResponse.originalError) {
      console.log("Error deleting kuorma", cResponse);
      return { error: true, msg: cResponse };
    }
    return toimitus;
  } catch (error) {
    console.log("Error deleting kuorma", error);
    return { error: true, msg: error };
  }
}
